export const LOS_VIEW_TYPE = Object.freeze({
  LOS: "los",
  EDLOS: "edlos",
  SSI_UPLINE_REPORT: "ssiUplineReport",
  BRONZE_GROUP_TRACKING: "bronzeGroupTracking",
});
